import { jsx as _jsx } from "react/jsx-runtime";
import { colors } from './colors';
import { Warning } from '../icons/Warning';
import { FormDown } from '../icons/FormDown';
import { FormUp } from '../icons/FormUp';
var isObject = function (item) {
    return item && typeof item === "object" && !Array.isArray(item);
};
var deepFreeze = function (obj) {
    Object.keys(obj).forEach(function (key) { return key && isObject(obj[key]) && Object.freeze(obj[key]); });
    return Object.freeze(obj);
};
export var theme = deepFreeze({
    name: "pentester",
    global: {
        colors: colors,
        font: {
            family: "'Montserrat', sans-serif",
            face: "\n      /* cyrillic-ext */\n      @font-face {\n      font-family: 'Montserrat';\n      font-style: normal;\n      font-weight: 100;\n      src: url(https://fonts.gstatic.com/s/montserrat/v24/JTUSjIg1_i6t8kCHKm459WRhyyTh89ZNpQ.woff2) format('woff2');\n      unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;\n      }\n      /* cyrillic */\n      @font-face {\n      font-family: 'Montserrat';\n      font-style: normal;\n      font-weight: 100;\n      src: url(https://fonts.gstatic.com/s/montserrat/v24/JTUSjIg1_i6t8kCHKm459W1hyyTh89ZNpQ.woff2) format('woff2');\n      unicode-range: U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;\n      }\n      /* latin-ext */\n      @font-face {\n      font-family: 'Montserrat';\n      font-style: normal;\n      font-weight: 100;\n      src: url(https://fonts.gstatic.com/s/montserrat/v24/JTUSjIg1_i6t8kCHKm459WdhyyTh89ZNpQ.woff2) format('woff2');\n      unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;\n      }\n      /* latin */\n      @font-face {\n      font-family: 'Montserrat';\n      font-style: normal;\n      font-weight: 100;\n      src: url(https://fonts.gstatic.com/s/montserrat/v24/JTUSjIg1_i6t8kCHKm459WlhyyTh89Y.woff2) format('woff2');\n      unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n      }\n      /* cyrillic-ext */\n      @font-face {\n      font-family: 'Montserrat';\n      font-style: normal;\n      font-weight: 300;\n      src: url(https://fonts.gstatic.com/s/montserrat/v24/JTUSjIg1_i6t8kCHKm459WRhyyTh89ZNpQ.woff2) format('woff2');\n      unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;\n      }\n      /* cyrillic */\n      @font-face {\n      font-family: 'Montserrat';\n      font-style: normal;\n      font-weight: 300;\n      src: url(https://fonts.gstatic.com/s/montserrat/v24/JTUSjIg1_i6t8kCHKm459W1hyyTh89ZNpQ.woff2) format('woff2');\n      unicode-range: U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;\n      }\n      /* latin-ext */\n      @font-face {\n      font-family: 'Montserrat';\n      font-style: normal;\n      font-weight: 300;\n      src: url(https://fonts.gstatic.com/s/montserrat/v24/JTUSjIg1_i6t8kCHKm459WdhyyTh89ZNpQ.woff2) format('woff2');\n      unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;\n      }\n      /* latin */\n      @font-face {\n      font-family: 'Montserrat';\n      font-style: normal;\n      font-weight: 300;\n      src: url(https://fonts.gstatic.com/s/montserrat/v24/JTUSjIg1_i6t8kCHKm459WlhyyTh89Y.woff2) format('woff2');\n      unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n      }\n      /* cyrillic-ext */\n      @font-face {\n      font-family: 'Montserrat';\n      font-style: normal;\n      font-weight: 400;\n      src: url(https://fonts.gstatic.com/s/montserrat/v24/JTUSjIg1_i6t8kCHKm459WRhyyTh89ZNpQ.woff2) format('woff2');\n      unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;\n      }\n      /* cyrillic */\n      @font-face {\n      font-family: 'Montserrat';\n      font-style: normal;\n      font-weight: 400;\n      src: url(https://fonts.gstatic.com/s/montserrat/v24/JTUSjIg1_i6t8kCHKm459W1hyyTh89ZNpQ.woff2) format('woff2');\n      unicode-range: U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;\n      }\n      /* latin-ext */\n      @font-face {\n      font-family: 'Montserrat';\n      font-style: normal;\n      font-weight: 400;\n      src: url(https://fonts.gstatic.com/s/montserrat/v24/JTUSjIg1_i6t8kCHKm459WdhyyTh89ZNpQ.woff2) format('woff2');\n      unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;\n      }\n      /* latin */\n      @font-face {\n      font-family: 'Montserrat';\n      font-style: normal;\n      font-weight: 400;\n      src: url(https://fonts.gstatic.com/s/montserrat/v24/JTUSjIg1_i6t8kCHKm459WlhyyTh89Y.woff2) format('woff2');\n      unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n      }\n      /* cyrillic-ext */\n      @font-face {\n      font-family: 'Montserrat';\n      font-style: normal;\n      font-weight: 600;\n      src: url(https://fonts.gstatic.com/s/montserrat/v24/JTUSjIg1_i6t8kCHKm459WRhyyTh89ZNpQ.woff2) format('woff2');\n      unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;\n      }\n      /* cyrillic */\n      @font-face {\n      font-family: 'Montserrat';\n      font-style: normal;\n      font-weight: 600;\n      src: url(https://fonts.gstatic.com/s/montserrat/v24/JTUSjIg1_i6t8kCHKm459W1hyyTh89ZNpQ.woff2) format('woff2');\n      unicode-range: U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;\n      }\n      /* latin-ext */\n      @font-face {\n      font-family: 'Montserrat';\n      font-style: normal;\n      font-weight: 600;\n      src: url(https://fonts.gstatic.com/s/montserrat/v24/JTUSjIg1_i6t8kCHKm459WdhyyTh89ZNpQ.woff2) format('woff2');\n      unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;\n      }\n      /* latin */\n      @font-face {\n      font-family: 'Montserrat';\n      font-style: normal;\n      font-weight: 600;\n      src: url(https://fonts.gstatic.com/s/montserrat/v24/JTUSjIg1_i6t8kCHKm459WlhyyTh89Y.woff2) format('woff2');\n      unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n      }\n      /* cyrillic-ext */\n      @font-face {\n      font-family: 'Montserrat';\n      font-style: normal;\n      font-weight: 800;\n      src: url(https://fonts.gstatic.com/s/montserrat/v24/JTUSjIg1_i6t8kCHKm459WRhyyTh89ZNpQ.woff2) format('woff2');\n      unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;\n      }\n      /* cyrillic */\n      @font-face {\n      font-family: 'Montserrat';\n      font-style: normal;\n      font-weight: 800;\n      src: url(https://fonts.gstatic.com/s/montserrat/v24/JTUSjIg1_i6t8kCHKm459W1hyyTh89ZNpQ.woff2) format('woff2');\n      unicode-range: U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;\n      }\n      /* latin-ext */\n      @font-face {\n      font-family: 'Montserrat';\n      font-style: normal;\n      font-weight: 800;\n      src: url(https://fonts.gstatic.com/s/montserrat/v24/JTUSjIg1_i6t8kCHKm459WdhyyTh89ZNpQ.woff2) format('woff2');\n      unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;\n      }\n      /* latin */\n      @font-face {\n      font-family: 'Montserrat';\n      font-style: normal;\n      font-weight: 800;\n      src: url(https://fonts.gstatic.com/s/montserrat/v24/JTUSjIg1_i6t8kCHKm459WlhyyTh89Y.woff2) format('woff2');\n      unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n      }",
        },
        active: {
            background: "active-background",
            color: "active-text",
        },
        hover: {
            background: "active-background",
            color: "active-text",
        },
        selected: {
            background: "selected-background",
            color: "selected-text",
        },
        control: {
            border: {
                radius: "4px",
                width: "0px",
            },
        },
        elevation: {
            light: {
                none: "none",
                xsmall: "0px 1px 2px rgba(100, 100, 100, 0.50)",
                small: "0px 4px 4px rgba(0, 0, 0, 0.25)",
                medium: "0px 3px 8px rgba(100, 100, 100, 0.50)",
                large: "0px 6px 12px rgba(100, 100, 100, 0.50)",
                xlarge: "0px 34px 92px rgba(121, 144, 176, 0.23);",
            },
            dark: {
                none: "none",
                xsmall: "none",
                small: "5px 8px 62px rgba(45, 66, 123, 0.168627);",
                medium: "none",
                large: "none",
                xlarge: "none",
            },
        },
        drop: {
            background: "background-front",
            border: {
                radius: "4px",
            },
            margin: "xsmall",
            intelligentMargin: true,
            elevation: "none",
        },
        size: {
            header: "85px",
        },
    },
    icon: {
        size: {
            xsmall: "7px",
            large: "32px",
        },
    },
    menu: {
        icons: {
            down: FormDown,
            up: FormUp,
        },
    },
    select: {
        icons: {
            down: FormDown,
            up: FormUp,
        },
    },
    tip: {
        content: {
            background: "background",
            elevation: "none",
            round: "none",
        },
    },
    layer: {
        background: "background-contrast",
        border: {
            intelligentRounding: true,
            radius: "14px",
        },
    },
    dataTable: {
        icons: {
            ascending: FormDown,
            descending: FormUp,
            expand: FormDown,
            contract: FormUp,
        },
        header: {
            pad: "medium",
            background: "selected-background",
        },
        pinned: {
            header: {
                background: "selected-background",
            },
        },
    },
    table: {
        header: {
            pad: "medium",
        },
        body: {
            pad: { horizontal: "medium", vertical: "small" },
        },
    },
    // TODO: This needs to be moved to nav menu in the landing-page
    // anchor: {
    //   color: {
    //     dark: `light-1`,
    //     light: `dark-1`,
    //   },
    //   hover: {
    //     textDecoration: `none`,
    //   },
    // },
    notification: {
        toast: {
            container: {
                elevation: "none",
            },
        },
    },
    button: {
        border: {
            radius: "5px",
        },
        padding: {
            vertical: "12px",
        },
        size: {
            small: {
                border: {
                    radius: "5px",
                },
            },
            medium: {
                border: {
                    radius: "5px",
                },
            },
            large: {
                border: {
                    radius: "5px",
                },
                pad: {
                    vertical: "16px",
                },
            },
        },
    },
    card: {
        body: {
            background: "selected-background",
            pad: { bottom: "small", horizontal: "small" },
            overflow: "auto",
        },
        container: {
            elevation: "none",
        },
        footer: {
            pad: "small",
            background: "selected-background",
        },
        header: {
            pad: "small",
            background: "selected-background",
        },
    },
    radioButton: {
        color: "brand",
        check: {
            color: "brand",
        },
    },
    checkBox: { color: "brand" },
    pageHeader: {
        pad: {
            top: "medium",
            bottom: "medium",
        },
        title: {
            level: 4,
        },
    },
    page: {
        full: {
            small: {
                pad: { bottom: "large" },
            },
            medium: {
                pad: { bottom: "medium" },
            },
            large: {
                pad: { bottom: "large" },
            },
        },
    },
    formField: {
        border: {
            side: "all",
            size: "small",
            position: "inner",
            error: {
                color: "status-critical",
            },
        },
        error: {
            margin: {
                horizontal: "none",
            },
            color: "text",
            container: {
                align: "center",
                gap: "xsmall",
            },
            icon: _jsx(Warning, { color: "status-critical" }),
        },
        label: {
            weight: 600,
            margin: {
                horizontal: "none",
            },
        },
        help: {
            color: "light-4",
            margin: {
                left: "none",
                bottom: "small",
            },
            style: { marginInlineStart: 0 },
            size: "xsmall",
        },
        round: "xsmall",
        margin: "none",
    },
    heading: {
        level: {
            '1': {
                small: {
                    size: "28px",
                    height: "34px",
                    maxWidth: "662px",
                },
                medium: {
                    size: "37px",
                    height: "43px",
                    maxWidth: "893px",
                },
                large: {
                    size: "56px",
                    height: "62px",
                    maxWidth: "1354px",
                },
                xlarge: {
                    size: "76px",
                    height: "82px",
                    maxWidth: "1814px",
                },
            },
            '2': {
                small: {
                    size: "25px",
                    height: "31px",
                    maxWidth: "605px",
                },
                medium: {
                    size: "32px",
                    height: "38px",
                    maxWidth: "778px",
                },
                large: {
                    size: "40px",
                    height: "46px",
                    maxWidth: "950px",
                },
                xlarge: {
                    size: "47px",
                    height: "53px",
                    maxWidth: "1123px",
                },
            },
            '3': {
                small: {
                    size: "23px",
                    height: "29px",
                    maxWidth: "547px",
                },
                medium: {
                    size: "28px",
                    height: "34px",
                    maxWidth: "662px",
                },
                large: {
                    size: "32px",
                    height: "38px",
                    maxWidth: "778px",
                },
                xlarge: {
                    size: "37px",
                    height: "43px",
                    maxWidth: "893px",
                },
            },
            '4': {
                small: {
                    size: "20px",
                    height: "26px",
                    maxWidth: "490px",
                },
                medium: {
                    size: "23px",
                    height: "29px",
                    maxWidth: "547px",
                },
                large: {
                    size: "25px",
                    height: "31px",
                    maxWidth: "605px",
                },
                xlarge: {
                    size: "28px",
                    height: "34px",
                    maxWidth: "662px",
                },
            },
            '5': {
                small: {
                    size: "16px",
                    height: "24px",
                    maxWidth: "403px",
                },
                medium: {
                    size: "16px",
                    height: "24px",
                    maxWidth: "403px",
                },
                large: {
                    size: "16px",
                    height: "24px",
                    maxWidth: "403px",
                },
                xlarge: {
                    size: "16px",
                    height: "24px",
                    maxWidth: "403px",
                },
            },
            '6': {
                small: {
                    size: "14px",
                    height: "22px",
                    maxWidth: "374px",
                },
                medium: {
                    size: "14px",
                    height: "22px",
                    maxWidth: "374px",
                },
                large: {
                    size: "14px",
                    height: "22px",
                    maxWidth: "374px",
                },
                xlarge: {
                    size: "14px",
                    height: "22px",
                    maxWidth: "374px",
                },
            },
        },
    },
    nameValuePair: {
        name: {
            weight: 600,
        },
    },
    paragraph: {
        small: {
            size: "14px",
            height: "24px",
            maxWidth: "403px",
        },
        medium: {
            size: "16px",
            height: "26px",
            maxWidth: "490px",
        },
        large: {
            size: "18px",
            height: "26px",
            maxWidth: "490px",
        },
        xlarge: {
            size: "20px",
            height: "29px",
            maxWidth: "547px",
        },
        xxlarge: {
            size: "24px",
            height: "34px",
            maxWidth: "662px",
        },
    },
    text: {
        xxsmall: {
            size: "12px",
            height: "20px",
            maxWidth: "348px",
        },
        xsmall: {
            size: "14px",
            height: "22px",
            maxWidth: "374px",
        },
        small: {
            size: "16px",
            height: "23px",
            maxWidth: "403px",
        },
        medium: {
            size: "18px",
            height: "24px",
            maxWidth: "403px",
        },
        large: {
            size: "20px",
            height: "26px",
            maxWidth: "490px",
        },
        xlarge: {
            size: "24px",
            height: "29px",
            maxWidth: "547px",
        },
        xxlarge: {
            size: "28px",
            height: "34px",
            maxWidth: "662px",
        },
    },
});
//# sourceMappingURL=theme.js.map